import React, { Fragment, useState, useEffect, useRef } from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Hero.scss';
import heroBackgroundImgLargeDesktop from '../../assets/ubisoft-plus_hero_large_desktop.jpg';
import heroBackgroundImgDesktop from '../../assets/ubisoft-plus_hero_desktop.jpg';
import heroBackgroundImgMobile from '../../assets/ubisoft-plus_hero_mobile.jpg';
import SubscriptionButton from '../SubscriptionButton/SubscriptionButton';
import CONFIG from '../../config';

interface IHeroProps {
  freeTrialEligible: boolean;
  context?: IContent;
}

const Hero = ({ context,  freeTrialEligible }: IHeroProps) => {
  const [heroTranslateY, setHeroTranslateY] = useState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  const icon = require(`../../assets/ubisoft_plus_logo.svg`);

  useEffect(() => {
    document.addEventListener('scroll', () => getHeroTranslateY(heroRef));
  });

  return (
    <div className="ubisoft-plus_hero" ref={heroRef}>
      <div className="ubisoft-plus_hero_inner">
        <div className="hero_background">
          <picture>
            <source media="(min-width:1921px)" srcSet={heroBackgroundImgLargeDesktop} />
            <source media="(min-width:1024px)" srcSet={heroBackgroundImgDesktop} />
            <source media="(min-width:0px)" srcSet={heroBackgroundImgMobile} />
            <img
              src={heroBackgroundImgDesktop}
              alt={context.hero.image_alt}
              data-animate="hero"
              style={{ transform: `translateY(${heroTranslateY}px)` }}
            />
          </picture>
        </div>
        <div className="ubisoft-plus_hero_content">
          <div className="ubisoft-plus_hero_content_inner">
            <div className="logo_container">
              <img className="ubisoft-plus_logo" src={icon} alt={context.hero.logo_alt} />
              <p className={'ubisoft-plus_logo-text'}>{context.hero.hero_main_title}</p>
            </div>
            <discover-components-subscription-price
              locale={context.lang.split('_')[0]}
              theme={CONFIG.isUPC ? 'uplay' : 'store'}
              customTheme={CONFIG.isUPC ? 'uplay' : 'store'}
              size="defaultSizes"
              textColor={'white'}
            ></discover-components-subscription-price>
            <div className={'hero-subdescription'}>
              <p>{context.hero.hero_subdescription}</p>
            </div>
            <SubscriptionButton  idToAttach={'heroSubscriptionButton'}/>
            <p className="hero_disclaimer">
              {freeTrialEligible &&
              context.subscribe_disclaimer !== '' &&
              context.subscribe_disclaimer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  function getHeroTranslateY(element: React.MutableRefObject<HTMLElement>) {
    let scrollTop = window.pageYOffset;
    const hero = element.current;
    const heroBackGroundImage = hero.querySelector('.hero_background img');
    const heroBackGroundImageProperties = heroBackGroundImage.getBoundingClientRect();
    const heroBottomPosition =
      hero.getBoundingClientRect().top + hero.offsetHeight;
    const heroBackGroundImagYPosition =
      heroBackGroundImageProperties.top + heroBackGroundImageProperties.height;
    const animationYDirection = -1;
    const velocity = scrollTop * 0.5;

    if (
      heroBottomPosition <=
      heroBackGroundImagYPosition + velocity * animationYDirection
    ) {
      setHeroTranslateY(velocity * animationYDirection);
    }
  }
};

export default withContent(Hero);
